import * as React from 'react';
import { inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import {
  ROUTE_LAUNCHING_ROCKET /*,
  ROUTE_SINGAPORE_FINISHED*/
} from '../../RouteList';
import {
  ROUTE_INTRO,
  ROUTE_GENDER,
  ROUTE_AGE,
  ROUTE_READY,
  ROUTE_SIZE
} from './RouteList';
import Intro from './components/Intro';
import Gender from './components/Gender';
import Age from './components/Age';
import Ready from './components/Ready';
import Size from './components/Size';
import SubPageController from '../components/SubPageController';
import SubPageNavigator from '../components/SubPageNavigator';
import Image, { ImageType } from '../../components/image/image';
import Container from '../../components/layout/container';
import Bubble, { BubbleType } from '../../components/bubble/bubble';
import classNames from 'classnames';

@inject('routing', 'dataStore')
class Fitting extends React.Component<any> {
  public state = {
    index: 0,
    total: 0
  };

  private subViewRoutes = [
    {
      path: ROUTE_INTRO,
      Component: Intro
    },
    {
      path: ROUTE_GENDER,
      Component: Gender,
      validator: () => this.props.dataStore.genderValidator(),
      private: true
    },
    {
      path: ROUTE_AGE,
      Component: Age,
      validator: () => this.props.dataStore.ageValidator(),
      private: true,
      excludeFromSingaporePrivate: true
    },
    {
      path: ROUTE_SIZE,
      Component: Size,
      validator: () => this.props.dataStore.sizeValidator()
    },
    {
      path: ROUTE_READY,
      Component: Ready
    }
  ];

  private onComplete = () => {
    const {
      dataStore: { saveData /*, isSingaporePrivate*/ },
      routing: { push }
    } = this.props;
    saveData();
    /*if (isSingaporePrivate) {
      push(ROUTE_SINGAPORE_FINISHED);
    } else {
      push(ROUTE_LAUNCHING_ROCKET);
    }*/
    push(ROUTE_LAUNCHING_ROCKET);
  };

  public render() {
    const {
      match,
      dataStore: { isPrivate, isSingaporePrivate }
    } = this.props;
    return (
      <Container>
        <Bubble type={BubbleType.Right}>
          <SubPageController
            subViewRoutes={this.subViewRoutes.filter(route =>
              isSingaporePrivate
                ? route.excludeFromSingaporePrivate !== isSingaporePrivate
                : route.private !== isPrivate
            )}
            match={match}
            onComplete={this.onComplete}
            render={renderProps => <SubPageNavigator {...renderProps} />}
          />
        </Bubble>
        <div className={classNames('c-image--wrapper')}>
          <Image
            type={ImageType.fittingKleermaker}
            imgSrc="/images/svg/fitting-kleermaker.svg"
            alt={'Sporti'}
          />
          <Image
            type={ImageType.fittingSuits}
            imgSrc="/images/svg/fitting-suits.svg"
            alt={'Rocket'}
          />
        </div>
      </Container>
    );
  }
}

export default withRouter(Fitting);



// WEBPACK FOOTER //
// ./src/containers/fitting/Fitting.tsx